import axios from 'axios';

export function fetch(options) {
    return new Promise((resolve, reject) => {
        const instance = axios.create({
            headers: {
                'Content-Type': 'application/json',
            },
            //withCredentials: true,  //表示跨域请求时是否需要使用凭证
            crossDomain: true,      //允许跨域
            timeout: 30 * 1000 // 30秒超时
        });
        instance(options)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                console.log('error' + error);
                reject(error);
            });
    });
}